import { render } from "./b-range.vue?vue&type=template&id=10f33f48&scoped=true&ts=true"
import script from "./b-range.vue?vue&type=script&lang=ts"
export * from "./b-range.vue?vue&type=script&lang=ts"

import "./b-range.vue?vue&type=style&index=0&id=10f33f48&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f33f48"]])

export default __exports__